// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2vnB9","title":"ClientInsurance_title__2skVX","itemText":"ClientInsurance_itemText__1vlvA"};